import { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Content, Sidebar, Navbar } from "./sections";
import { About, Blog, Contact, Home, Portfolio, Resume } from "./Pages";
import { Error404, Main } from "./Components";
import "react-loading-skeleton/dist/skeleton.css";
import axios from "axios";
import { baseUrl } from "./config/api";

import "./App.css";
import { SkeletonTheme } from "react-loading-skeleton";

const App = () => {
  // About data state
  const [aboutData, setAboutData] = useState(null);
  const [aboutLoading, setAboutLoading] = useState(true);
  const [aboutError, setAboutError] = useState(null);

  // Sidbar data state
  const [sidebarData, setSidebarData] = useState(null);

  // Contact Us data state
  const [contactUsData, setContactUsData] = useState(null);

  // --> About Fetch data
  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        setAboutLoading(true);
        const res = await axios.get(`${baseUrl}/about.json`);

        const sideData = {
          name: res.data.about.name,
          avatar: res.data.about.avatar,
          job_name: res.data.about.job_name,
          birthday: res.data.about.birthday,
          contacts: res.data.contacts,
        };

        const contactData = res.data.contacts;

        setSidebarData(sideData);
        setAboutData(res.data);
        setContactUsData(contactData);
      } catch (err) {
        console.error("Error fetching data:", err);
        setAboutError("Failed to load data. Please try again later.");
      } finally {
        setAboutLoading(false);
      }
    };

    fetchAboutData();
  }, []);

  return (
    <>
      <Router>
        <Home>
          <SkeletonTheme
            baseColor="#cc9862ff"
            highlightColor="#f3f4f6"
            duration={1.5}
          >
            <Main>
              <Sidebar aboutLoading={aboutLoading} sidebarData={sidebarData} />
              <Content>
                <Navbar />
                <Routes>
                  <Route
                    path="/"
                    element={
                      <About
                        aboutData={aboutData}
                        aboutLoading={aboutLoading}
                        aboutError={aboutError}
                      />
                    }
                  />
                  <Route path="/resume" element={<Resume />} />
                  <Route path="/portfolio" element={<Portfolio />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route
                    path="/contact"
                    element={
                      <Contact
                        contactUsData={contactUsData}
                        aboutLoading={aboutLoading}
                        aboutError={aboutError}
                      />
                    }
                  />
                  <Route path="/*" element={<Error404 />} />
                </Routes>
              </Content>
            </Main>
          </SkeletonTheme>
        </Home>
      </Router>
    </>
  );
};

export default App;
